import { Pixall, Google } from '../analytics/index.js';
import { getInventoryOwnerById, isVDP } from '../utilities/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';
import { getCDLVehicleTransformer } from '../transformers/pixall/inventoryTransformer';
import { getCDLVehicleSearch, getPageId } from '../transformers/pixall/DataLayerTransformer';

/**
 * @summary Sends an Pixall/Google events for compare trim features button click
 * @events event1
 */
export async function compareTrimFeaturesClick(_ref, option) {
  let {
    data = {},
    dataLayer = {},
    state
  } = _ref;
  const pageName = 'bld_and_pr';
  const {
    inventoryId,
    trimSelected,
    selectedVrsData = {}
  } = data;
  const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  const vehicleData = googleInventoryTransformer(inventoryWithOwner, {
    target: 'vehicle',
    dataLayer
  });
  const cdl = {
    eventProperties: {
      vehicle: getCDLVehicleTransformer({
        ...vehicleData,
        ...selectedVrsData,
        trimId: trimSelected,
        fuelType: vehicleData.fuelType ?? selectedVrsData?.engineType
      }),
      vehicleSearch: getCDLVehicleSearch(dataLayer)
    }
  };
  const pixallData = {
    assistProduct: 'Build_and_Price',
    eventSource: 'vehicle',
    eventType: 'click',
    label: `comp_trim_fts - ${trimSelected}`,
    listingType: pageName,
    pageid: pageName,
    pageType: 'buildprice',
    vehicleType: 'NEW',
    year: inventoryWithOwner?.year ?? '',
    cdl
  };
  delete inventoryWithOwner.id;
  Pixall.sendClickEvent({
    ...pixallData,
    inventoryWithOwner
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventAction: 'submit',
    eventResult: 'cta::compare-trim-features',
    eventData: {
      vehicle: vehicleData
    }
  }, option);
  return {
    cmp: 'comp_trim_fts',
    ...pixallData
  };
}
export async function bodyStyleTabClick(_ref2, option) {
  let {
    data = {},
    dataLayer,
    state
  } = _ref2;
  const pageName = 'bld_and_pr';
  const {
    inventoryId,
    bodyStyle
  } = data;
  const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  const pixallData = {
    assistProduct: 'Build_and_Price',
    eventSource: 'vehicle',
    eventType: 'click',
    label: 'bodystyle_pref - bld_and_pr',
    listingType: pageName,
    pageid: pageName,
    pageType: 'buildprice',
    vehicleType: 'NEW'
  };
  Pixall.sendClickEvent({
    ...pixallData,
    inventoryWithOwner
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'oem',
    eventResult: `cta::body-style::${bodyStyle}`
  }, option);
  return {
    cmp: 'bodystyle_pref',
    ...pixallData
  };
}

/**
 * @summary Sends Google event for custom order you vehicle by make on hp impression
 */
export async function customOrderByMakeImpression(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const googleData = {
    eventElement: 'build-price',
    eventResult: 'cta::custom-order-your-new-car',
    eventNonInteractive: true
  };
  Google.sendImpressions(metadata, googleData, option);
  return {};
}

/**
 * @summary Sends Google event for custom order you vehicle by make on hp see more click
 */
export async function customOrderSeeMoreClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  Google.sendClickEvent({
    eventElement: 'build-price',
    eventResult: 'text-link::show-more'
  }, option);
  return {};
}

/**
 * @summary Sends Google event for custom order you vehicle by make on hp make click
 */
export async function customOrderByMakeClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const make = metadata.data.label;
  Google.sendClickEvent({
    eventElement: 'build-price',
    eventResult: `cta::build_price::${make}`
  }, option);
  return {};
}

/**
 * @summary Sends Google event for custom order link on Location Filter SRP click
 */
export async function customBuildConditionFilterClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    label
  } = metadata.data;
  Google.sendClickEvent({
    eventElement: 'oem',
    eventResult: `text-link::open::${label}`
  }, option);
  return {};
}
export function buildAndPriceClick(_ref3, option) {
  let {
    data = {},
    state,
    dataLayer
  } = _ref3;
  const {
    par = '',
    inventoryId,
    ownerId
  } = data;
  const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
  const id = inventoryWithOwner?.owner?.id || ownerId;
  const pageId = getPageId(dataLayer);
  Pixall.sendClickEvent({
    label: `bld_pr - ${pageId}`,
    feature: 'New Car Order',
    listingCode: id,
    par,
    eventSource: 'dealership',
    inventory: {
      ...inventoryWithOwner,
      type: 'new'
    },
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    }
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'build-price',
    eventResult: 'cta::open::build-price',
    eventData: {
      vehicle: {
        clickType: 'newcarcustomorder'
      }
    }
  }, option);
  return {};
}
export default {
  bodyStyleTabClick,
  buildAndPriceClick,
  compareTrimFeaturesClick,
  customOrderByMakeImpression,
  customOrderSeeMoreClick,
  customOrderByMakeClick,
  customBuildConditionFilterClick
};